import styled from "styled-components"

export const StyledMessage = styled.div`
  margin: 15px 0;

  .message-username {
    font-size: 1rem;
    color: black;
    font-weight:bold;
    opacity: 0.9;
    margin-bottom: 6px;
  }

  .message-text {
    background: white;
    font-size:1.5rem;
    color: black;
    display: inline;
    padding: 4px 8px;
    border-radius: 8px;
  }
`
